// extracted by mini-css-extract-plugin
export var btn = "Share-module--btn--qvZHC";
export var list = "Share-module--list--9SJb5";